
import Shuffle from "../../../assets/outline/Shuffle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ShuffleIcon({ className, dataTestid = "ShuffleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Shuffle data-testid={dataTestid} className={classes} {...rest} />
  );
}
